module.exports = __webpack_public_path__ + "static/media/Brandon_bld.b0015678.woff2";